import type {SketchEllipseObject} from '../sketch/SketchEllipseObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图椭圆对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图椭圆协议时返回 true。
 */
export function isSketchEllipseObject(value: unknown): value is SketchEllipseObject {
	// 基于运行时标记进行协议判断。
	return hasRuntimeFlag(value, 'isSketchEllipseObject');
}
